import './dialogModal.css';
import { useEffect, useRef } from 'react';
import ReactLoading from 'react-loading';

const Dialog = ({ openModal, heading, children, className, loading }) => {
    const ref = useRef();

    useEffect(() => {
        if (openModal) {
            ref.current?.showModal();
        } else {
            ref.current?.close();
        }
    }, [openModal]);

    return (
        <dialog ref={ref} className={`dialog ${className}`}>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <h4 className='dialogHeading'>{heading}</h4>
            {children}
        </dialog>
    );
};

export default Dialog;
